import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { Url } from 'app/shared/constants/url';
import { CompanyBankFilter } from 'app/shared/filters/company-bank.filter';
import { CompanyBank } from 'app/shared/models/company-bank.model';
import { Company } from 'app/shared/models/company.model';
import { EventService } from 'app/shared/services/event.service';
import { GenericService } from 'app/shared/services/generic.service';
import { SectionService } from 'app/shared/services/section.service';
import { Utils } from 'app/shared/utils/utils';
import { PaginationService } from 'ngx-pagination';

@Component({
  selector: 'app-company-banks',
  templateUrl: './company-banks.component.html',
  styleUrls: ['./company-banks.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class CompanyBanksComponent extends ListBaseComponent implements OnInit {

  @Input() company: Company;

  consentLinkExpirationDateDisplayClass: string = "d-none";
  fieldCollection: any[] = [];

  companyBankFilter: CompanyBankFilter;
  permissionsLoaded: boolean = false;
  showConsentLinkExpirationDate: boolean = false;

  get hasConsentLinkExpirationDateViewPermission(): boolean {
    return this.hasPermission(Permissions.CompanyBanks_ConsentLinkExpirationDate_View);
  }

  constructor(protected sectionService: SectionService, protected genericService: GenericService, protected modalService: NgbModal, protected translateService: TranslateService,
              protected eventService: EventService) {
    super(sectionService, Sections.CompanyBanks, modalService, Modals.CompanyBankComponent);
  }

  ngOnInit() {
    this.companyBankFilter = new CompanyBankFilter(this.company.CompanyId);
    super.initializeView(Constants.CompanyBanks_DefaultSortField, Constants.CompanyBanks_DefaultSortDirectionAscending);

    this.eventService.permissionsLoadedEvent.subscribe(() => {
      this.permissionsLoaded = true;
      this.showConsentLinkExpirationDate = this.hasConsentLinkExpirationDateViewPermission;
      if (this.showConsentLinkExpirationDate) {
        this.consentLinkExpirationDateDisplayClass = "";
      }
      this.initializeFieldCollection();
    });
  }

  initializeFieldCollection() {
    this.fieldCollection = [
      {
        name: 'CompanyBankId',
        displayName: 'companyBanks.companyBankIdFieldTitle',
        canSort: true,
        displayClass: "d-none d-lg-table-cell"
      },
      {name: 'BankName', displayName: 'companyBanks.bankNameFieldTitle', canSort: true, displayClass: ""},
      {
        name: 'ConsentLinkExpirationDate',
        displayName: 'companyBanks.consentLinkExpirationDateFieldTitle',
        canSort: true,
        displayClass: this.consentLinkExpirationDateDisplayClass
      },
      {
        name: 'ConsentExpirationDate',
        displayName: 'companyBanks.consentExpirationDateFieldTitle',
        canSort: true,
        displayClass: ""
      },
      {name: 'Consent', displayName: 'companyBanks.consentFieldTitle', canSort: false, displayClass: ""},
    ];
  }

  openModal() {
    const modalReference = super.openModal();
    modalReference.componentInstance.companyId = this.company.CompanyId;

    return modalReference;
  }

  openEditModal(currentObject: object, readonly: boolean = false) {
    const modalReference = super.openEditModal(currentObject, readonly);
    modalReference.componentInstance.companyId = this.company.CompanyId;
    modalReference.componentInstance.currentObject = Object.assign({}, currentObject);
    modalReference.componentInstance.isEditMode = true;

    return modalReference;
  }

  consentUrlInvalid(companyBank: CompanyBank): boolean {
    return Utils.isStringNullOrWhiteSpace(companyBank.ConsentLink);
  }

  openConsentUrl(companyBank: CompanyBank) {
    window.open(companyBank.ConsentLink, '_blank');
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.genericService.getCollectionPaginated<CompanyBank>(Url.CompanyBank, this.pageConfiguration, this.companyBankFilter, (collection) => this.collection = collection);
  }
}
